module.exports = __webpack_public_path__ + "static/media/test28.2ca764a6.jpeg";